import type { FC, ReactNode } from 'react'

import { useNow } from '@/hooks/use-now'
import { formatLongDate, formatTime, formatWeekdayDate } from '@/lib/carwash/format'

/* Each part subscribes to the shared clock on its own, so only the text re-renders. */

export const LiveTime: FC<{ className?: string }> = ({ className }): ReactNode => {
    const now = useNow(1000)

    return (
        <time className={className} dateTime={now ? new Date(now).toISOString() : undefined} suppressHydrationWarning>
            {now ? formatTime(now) : ' '}
        </time>
    )
}

export const LiveDate: FC<{ className?: string, long?: boolean }> = ({ className, long = false }): ReactNode => {
    const now = useNow(60_000)

    return (
        <span className={className} suppressHydrationWarning>
            {now ? (long ? formatLongDate(now) : formatWeekdayDate(now)) : ' '}
        </span>
    )
}
